import { UsTaxNoReturnReasonCode } from '@/types/api/tax-info';

export const US_TAX_NO_RETURN_REASON_OTHER_MAX_LENGTH = 80;

export const US_TAX_NO_RETURN_REASON_CODES = [
  UsTaxNoReturnReasonCode.RENOUNCED_CITIZENSHIP,
  UsTaxNoReturnReasonCode.RENOUNCED_GREEN_CARD,
  UsTaxNoReturnReasonCode.US_ADDRESS_TEMPORARY_ONLY,
  UsTaxNoReturnReasonCode.EXEMPT_UNDER_TAX_TREATY,
  UsTaxNoReturnReasonCode.OTHER,
] as const;
